import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { refreshToken, apiGet } from '../api/client';
import { useAuthStore } from '../store/authStore';

export default function AuthGoogleSuccess() {
  const navigate = useNavigate();
  const setAuth = useAuthStore(s => s.setAuth);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    (async () => {
      try {
        const token = await refreshToken();
        if (!token) {
          navigate('/login?error=google_auth_failed', { replace: true });
          return;
        }
        const user = await apiGet<{ id: string; email: string; name: string; role: string; permissions?: Record<string, boolean> }>('/auth/me');
        setAuth(token, user);
        navigate('/dashboard', { replace: true });
      } catch {
        navigate('/login?error=google_auth_failed', { replace: true });
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-bg)',
      flexDirection: 'column',
      gap: '1rem',
    }}>
      <svg width="40" height="40" viewBox="0 0 18 18" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.185l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
        <path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z"/>
        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.962L3.964 6.294C4.672 4.169 6.656 3.58 9 3.58z"/>
      </svg>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Accesso con Google in corso…
      </p>
    </div>
  );
}
